<template>
  <div class="wcdiv wcpage" style="width: 595.3pt; height: 841.9pt">
    <div class="wcdiv" style="left: 28.35pt; top: 28.35pt">
      <div
        class="wcdiv"
        style="
          left: -0.05pt;
          top: -0.05pt;
          width: 383.9pt;
          height: 20.7pt;
          background-color: #d8d8d8;
          border: solid 0.1pt #d8d8d8;
        "
      >
        <br />
      </div>
      <span
        class="wcspan wctext002"
        style="font-size: 16pt; left: 0pt; top: 1.61pt"
        >第二部份：飲食習慣、健康危險因子認知、及政策調查</span
      >
      <div class="wcdiv" style="top: 20.8pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >1.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您平均每天吃幾份蔬菜？
          {{ ifq("1.請問您平均每天吃幾份蔬菜？", "0.沒吃", "■", "□") }}0.沒吃
          {{
            ifq("1.請問您平均每天吃幾份蔬菜？", "1.不到3份", "■", "□")
          }}1.不到3份
          {{
            ifq("1.請問您平均每天吃幾份蔬菜？", "2.3份以上", "■", "□")
          }}2.3份以上</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 37.05pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >(煮過的蔬菜1份約正常飯碗半碗)</span
        >
      </div>
      <div class="wcdiv" style="top: 53.29pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >2.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您平均每天吃幾份水果？
          {{ ifq("2.請問您平均每天吃幾份水果？", "0.沒吃", "■", "□") }}0.沒吃
          {{
            ifq("2.請問您平均每天吃幾份水果？", "1.不到2份", "■", "□")
          }}1.不到2份
          {{
            ifq("2.請問您平均每天吃幾份水果？", "2.2份以上", "■", "□")
          }}2.2份以上</span
        >
      </div>
      <div class="wcdiv" style="left: 18pt; top: 69.54pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >(1份約1個拳頭大小，如半根香蕉、一顆蘋果)</span
        >
      </div>
      <div class="wcdiv" style="top: 85.79pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >3.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您目前是否有服用中(草)藥的習慣？(不包含中醫師開立之藥方，最近一個月內)</span
        >
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 102.04pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "3.請問您目前是否有服用中(草)藥的習慣？(不包含中醫師開立之藥方，最近一個月內)",
              "0.從沒吃過",
              "■",
              "□"
            )
          }}0.從沒吃過;
          {{
            ifq(
              "3.請問您目前是否有服用中(草)藥的習慣？(不包含中醫師開立之藥方，最近一個月內)",
              "1.目前有",
              "■",
              "□"
            )
          }}1.目前有;
          {{
            ifq(
              "3.請問您目前是否有服用中(草)藥的習慣？(不包含中醫師開立之藥方，最近一個月內)",
              "2.過去有，現在沒吃，停用幾年？",
              "■",
              "□"
            )
          }}2.過去有，現在沒吃; 停用</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 325pt; top: 0pt"
          >&nbsp;{{
            ifqOther(
              "3.請問您目前是否有服用中(草)藥的習慣？(不包含中醫師開立之藥方，最近一個月內)",
              "2.過去有，現在沒吃，停用幾年？"
            )
          }}</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >年</span
        >
        <div
          class="wcdiv"
          style="
            left: 325pt;
            top: 13.47pt;
            width: 31.25pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 118.29pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >答有或過去有者續問：</span
        >
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 134.53pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >3-1 食用目的：{{ ifq("3-1 食用目的：", "0.養生", "■", "□") }}0.養生
          {{ ifq("3-1 食用目的：", "1.治病", "■", "□") }}1.治病
          {{ ifq("3-1 食用目的：", "2.其他", "■", "□") }}2.其他：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 262.5pt; top: 0pt"
          >&nbsp;{{ ifqOther("3-1 食用目的：", "2.其他") }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 262.5pt;
            top: 13.47pt;
            width: 81.25pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 150.78pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >3-2 中(草)藥來源：{{
            ifq("3-2 中(草)藥來源：", "0.中藥店", "■", "□")
          }}0.中藥店
          {{ ifq("3-2 中(草)藥來源：", "1.中醫診所", "■", "□") }}1.中醫診所
          {{ ifq("3-2 中(草)藥來源：", "2.朋友介紹", "■", "□") }}2.朋友介紹
          {{ ifq("3-2 中(草)藥來源：", "3.自製", "■", "□") }}3.自製
          {{ ifq("3-2 中(草)藥來源：", "4.其他", "■", "□") }}4.其他</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 450pt; top: 0pt"
          >&nbsp;{{ ifqOther("3-2 中(草)藥來源：", "4.其他") }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 450pt;
            top: 13.47pt;
            width: 50pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 167.03pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >3-3 種類：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 62.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <div
          class="wcdiv"
          style="left: 62.5pt; top: 0pt; width: 175pt; height: 0pt"
        >
          {{ ift("3-3 種類：") }}
        </div>
        <div
          class="wcdiv"
          style="
            left: 62.5pt;
            top: 13.47pt;
            width: 175pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="top: 183.28pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >4.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您是否曾經自行購買藥物？</span
        >
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 199.53pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("4.請問您是否曾經自行購買藥物？", "0.從來沒有", "■", "□")
          }}0.從來沒有
          {{ ifq("4.請問您是否曾經自行購買藥物？", "1.有", "■", "□") }}1.有
          {{
            ifq(
              "4.請問您是否曾經自行購買藥物？",
              "2.過去有，現在沒有",
              "■",
              "□"
            )
          }}2.過去有，現在沒有</span
        >
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 215.77pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >答有或過去有者續問：</span
        >
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 232.02pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >4-1 食用目的：{{ ifq("4-1 食用目的：", "0.養生", "■", "□") }}0.養生
          {{ ifq("4-1 食用目的：", "1.治病", "■", "□") }}1.治病
          {{ ifq("4-1 食用目的：", "2.其他", "■", "□") }}2.其他：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 262.5pt; top: 0pt"
          >&nbsp;{{ ifqOther("4-1 食用目的：", "2.其他") }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 262.5pt;
            top: 13.47pt;
            width: 75pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="left: 12.5pt; top: 248.27pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >4-2 購買來源：{{
            ifq("4-2 購買來源：", "0.醫師或藥師介紹", "■", "□")
          }}0.醫師或藥師介紹
          {{ ifq("4-2 購買來源：", "1.親友介紹", "■", "□") }}1.親友介紹
          {{
            ifq("4-2 購買來源：", "2.自己買書閱讀得知", "■", "□")
          }}2.自己買書閱讀得知</span
        >
      </div>
      <div class="wcdiv" style="left: 102.25pt; top: 264.52pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("4-2 購買來源：", "3.電視、電台廣告", "■", "□")
          }}3.電視、電台廣告
          {{ ifq("4-2 購買來源：", "4.直銷商", "■", "□") }}4.直銷商</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 181.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 200pt; top: 1.26pt"
          >{{ ifq("4-2 購買來源：", "5.其他", "■", "□") }}5.其他：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 262.5pt; top: 0pt"
          >&nbsp;{{ ifqOther("4-2 購買來源：", "5.其他") }}</span
        >
        <div
          class="wcdiv"
          style="
            left: 262.5pt;
            top: 13.47pt;
            width: 118.75pt;
            height: 0pt;
            border-top: solid 0.75pt #000000;
          "
        >
          <br />
        </div>
      </div>
      <div class="wcdiv" style="top: 280.77pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >5.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您知不知道血壓、血糖沒控制好，會引起洗腎(洗腰子)嗎?&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 297.01pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "5.請問您知不知道血壓、血糖沒控制好，會引起洗腎(洗腰子)嗎?",
              "0.知道",
              "■",
              "□"
            )
          }}0.知道
          {{
            ifq(
              "5.請問您知不知道血壓、血糖沒控制好，會引起洗腎(洗腰子)嗎?",
              "1.不知道",
              "■",
              "□"
            )
          }}1.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 313.26pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >6.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您知不知道慢性腎臟疾病與高血壓、</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 239.05pt; top: 1.26pt"
          >糖尿病、</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 288.9pt; top: 1.26pt"
          >痛風、</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 326.25pt; top: 1.26pt"
          >使用一些來路不明的祕方、</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 476.1pt; top: 1.26pt"
          >中草藥或是</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 17.51pt"
          >非醫師處方的止痛藥、抗生素等有關?</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 345.76pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "6.請問您知不知道慢性腎臟疾病與高血壓、糖尿病、痛風、使用一些來路不明的祕方、中草藥或是非醫師處方的止痛藥、抗生素等有關?",
              "0.知道",
              "■",
              "□"
            )
          }}0.知道
          {{
            ifq(
              "6.請問您知不知道慢性腎臟疾病與高血壓、糖尿病、痛風、使用一些來路不明的祕方、中草藥或是非醫師處方的止痛藥、抗生素等有關?",
              "1.不知道",
              "■",
              "□"
            )
          }}1.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 362.01pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >7.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您知不知道自己的血壓值?&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 13.63pt; top: 378.25pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{ ifq("7.請問您知不知道自己的血壓值?", "0.知道", "■", "□") }}0.知道
          {{
            ifq("7.請問您知不知道自己的血壓值?", "1.不知道", "■", "□")
          }}1.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 394.5pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >8.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您認為十八歲以上成人血壓值在什麼範圍內才算標準?</span
        >
      </div>
      <div class="wcdiv" style="top: 410.75pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 12.5pt; top: 1.26pt"
        >
          {{
            ifq(
              "8.請問您認為十八歲以上成人血壓值在什麼範圍內才算標準?",
              "0.120/80以內",
              "■",
              "□"
            )
          }}0.120/80以內
          {{
            ifq(
              "8.請問您認為十八歲以上成人血壓值在什麼範圍內才算標準?",
              "0.130/85以內",
              "■",
              "□"
            )
          }}0.130/85以內
          {{
            ifq(
              "8.請問您認為十八歲以上成人血壓值在什麼範圍內才算標準?",
              "1.140/90以內",
              "■",
              "□"
            )
          }}1.140/90以內
          {{
            ifq(
              "8.請問您認為十八歲以上成人血壓值在什麼範圍內才算標準?",
              "2.不知道",
              "■",
              "□"
            )
          }}2.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 427pt">
        <a name="_Hlk531799320" style="left: 0pt; top: 0pt">&nbsp;</a>
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >9.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 14.2pt; top: 1.26pt"
          >請問您過去1年量測血壓的習慣為何?</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 443.25pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("9.請問您過去1年量測血壓的習慣為何?", "0.不曾量過", "■", "□")
          }}0.不曾量過</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 137.5pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您過去1年量測血壓的習慣為何?",
              "1.未定期量血壓",
              "■",
              "□"
            )
          }}1.未定期量血壓</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 237.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 275pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您過去1年量測血壓的習慣為何?",
              "2.每天2次(含)以上",
              "■",
              "□"
            )
          }}2.每天2次(含)以上</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 393.75pt; top: 1.26pt"
          >&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 14.2pt; top: 459.49pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您過去1年量測血壓的習慣為何?",
              "3.每週1次(含)以上",
              "■",
              "□"
            )
          }}3.每週1次(含)以上</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 118.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 137.5pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您過去1年量測血壓的習慣為何?",
              "4.每3-6個月至少1次",
              "■",
              "□"
            )
          }}4.每3-6個月至少1次</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 262.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 275pt; top: 1.26pt"
          >{{
            ifq(
              "9.請問您過去1年量測血壓的習慣為何?",
              "5.每年至少1次",
              "■",
              "□"
            )
          }}5.每年至少1次</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 368.75pt; top: 1.26pt"
          >&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="top: 475.74pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >10.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問您知不知道自己空腹的血糖值?&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 491.99pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq("10.請問您知不知道自己空腹的血糖值?", "0.知道", "■", "□")
          }}0.知道
          {{
            ifq("10.請問您知不知道自己空腹的血糖值?", "1.不知道", "■", "□")
          }}1.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 508.24pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >11.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問您認為十八歲以上成人空腹血糖值在什麼範圍內才算標準?</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 524.49pt">
        <a name="_Hlk531706714" style="left: 0pt; top: 0pt">&nbsp;</a>
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "11.請問您認為十八歲以上成人空腹血糖值在什麼範圍內才算標準?",
              "0.100以內",
              "■",
              "□"
            )
          }}0.100以內
          {{
            ifq(
              "11.請問您認為十八歲以上成人空腹血糖值在什麼範圍內才算標準?",
              "1.130以內",
              "■",
              "□"
            )
          }}1.130以內
          {{
            ifq(
              "11.請問您認為十八歲以上成人空腹血糖值在什麼範圍內才算標準?",
              "2.150以內",
              "■",
              "□"
            )
          }}2.150以內
          {{
            ifq(
              "11.請問您認為十八歲以上成人空腹血糖值在什麼範圍內才算標準?",
              "3.不知道",
              "■",
              "□"
            )
          }}3.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 540.73pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >12.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問您以前有聽過「身體質量指數」或是「BMI」嗎？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 556.98pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "12.請問您以前有聽過「身體質量指數」或是「BMI」嗎？",
              "0.是",
              "■",
              "□"
            )
          }}0.是
          {{
            ifq(
              "12.請問您以前有聽過「身體質量指數」或是「BMI」嗎？",
              "1.否",
              "■",
              "□"
            )
          }}1.否。</span
        >
      </div>
      <div class="wcdiv" style="top: 573.23pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >13.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問我國18歲以上成人肥胖是指身體質量指數(BMI)大於25、</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 348.7pt; top: 1.26pt"
          >27還是30？（BMI的計算方式為</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 513.6pt; top: 1.26pt"
          >「體</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 17.51pt"
          >重(公斤)&divide;身高(公尺)&divide;身高(公尺)」）{{
            ifq(
              "13.請問我國18歲以上成人肥胖是指身體質量指數(BMI)大於25、27還是30？",
              "1. ≧25",
              "■",
              "□"
            )
          }}1.≧25
          {{
            ifq(
              "13.請問我國18歲以上成人肥胖是指身體質量指數(BMI)大於25、27還是30？",
              "2. ≧27",
              "■",
              "□"
            )
          }}2.≧27
          {{
            ifq(
              "13.請問我國18歲以上成人肥胖是指身體質量指數(BMI)大於25、27還是30？",
              "3. ≧30",
              "■",
              "□"
            )
          }}3.≧30
          {{
            ifq(
              "13.請問我國18歲以上成人肥胖是指身體質量指數(BMI)大於25、27還是30？",
              "4.不知道",
              "■",
              "□"
            )
          }}4.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 605.73pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >14.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問您成年男性腰圍在什麼範圍內才算標準?&nbsp;</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 621.97pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "14.請問您成年男性腰圍在什麼範圍內才算標準?",
              "0.90公分以內【35吋】",
              "■",
              "□"
            )
          }}0.90公分以內【35吋】
          {{
            ifq(
              "14.請問您成年男性腰圍在什麼範圍內才算標準?",
              "1.80公分以內【31吋】",
              "■",
              "□"
            )
          }}1.80公分以內【31吋】
          {{
            ifq(
              "14.請問您成年男性腰圍在什麼範圍內才算標準?",
              "2.不知道",
              "■",
              "□"
            )
          }}2.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 638.22pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >15.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問您成年女性腰圍在什麼範圍內才算標準?</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 654.47pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "15.請問您成年女性腰圍在什麼範圍內才算標準?",
              "0.90公分以內【35吋】",
              "■",
              "□"
            )
          }}0.90公分以內【35吋】
          {{
            ifq(
              "15.請問您成年女性腰圍在什麼範圍內才算標準?",
              "1.80公分以內【31吋】",
              "■",
              "□"
            )
          }}1.80公分以內【31吋】
          {{
            ifq(
              "15.請問您成年女性腰圍在什麼範圍內才算標準?",
              "2.不知道",
              "■",
              "□"
            )
          }}2.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 670.72pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >16.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >請問我國民眾十大死亡原因第一位是哪個疾病？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 686.97pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "16.請問我國民眾十大死亡原因第一位是哪個疾病？",
              "0.心血管疾病",
              "■",
              "□"
            )
          }}0.心血管疾病</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 87.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 118.75pt; top: 1.26pt"
          >{{
            ifq(
              "16.請問我國民眾十大死亡原因第一位是哪個疾病？",
              "1.糖尿病",
              "■",
              "□"
            )
          }}1.糖尿病</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 181.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 212.5pt; top: 1.26pt"
          >{{
            ifq(
              "16.請問我國民眾十大死亡原因第一位是哪個疾病？",
              "2.癌症",
              "■",
              "□"
            )
          }}2.癌症</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 262.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 293.75pt; top: 1.26pt"
          >{{
            ifq(
              "16.請問我國民眾十大死亡原因第一位是哪個疾病？",
              "3.腎臟病",
              "■",
              "□"
            )
          }}3.腎臟病</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 356.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 387.5pt; top: 1.26pt"
          >{{
            ifq(
              "16.請問我國民眾十大死亡原因第一位是哪個疾病？",
              "4.不知道",
              "■",
              "□"
            )
          }}4.不知道。</span
        >
      </div>
      <div class="wcdiv" style="top: 703.21pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >17.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >癌症早期發現與晚期發現的存活率是否有差異？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 719.46pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "17.癌症早期發現與晚期發現的存活率是否有差異？",
              "0.早期發現治療效果好",
              "■",
              "□"
            )
          }}0.早期發現治療效果好</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 137.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 150pt; top: 1.26pt"
          >{{
            ifq(
              "17.癌症早期發現與晚期發現的存活率是否有差異？",
              "1.晚期發現治療效果好",
              "■",
              "□"
            )
          }}1.晚期發現治療效果好</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 287.5pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 306.25pt; top: 1.26pt"
          >{{
            ifq(
              "17.癌症早期發現與晚期發現的存活率是否有差異？",
              "2.沒差別",
              "■",
              "□"
            )
          }}2.沒差別</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 368.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 387.5pt; top: 1.26pt"
          >{{
            ifq(
              "17.癌症早期發現與晚期發現的存活率是否有差異？",
              "3.不知道",
              "■",
              "□"
            )
          }}3.不知道</span
        >
      </div>
      <div class="wcdiv" style="top: 735.71pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >18.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 1.26pt"
          >有</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 33.8pt; top: 1.26pt"
          >一種</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 58.8pt; top: 1.26pt"
          >說法「吃檳榔即使不加配料，也會導致癌症」</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 302.55pt; top: 1.26pt"
          >（配料</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 339.33pt; top: 1.26pt"
          >：</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 351.1pt; top: 1.26pt"
          >包括紅灰、白灰、荖花、荖藤、荖</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 21.3pt; top: 17.51pt"
          >葉&hellip;等等）</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 77.55pt; top: 17.51pt"
          >，請問您認為這種說法對不對？</span
        >
      </div>
      <div class="wcdiv" style="left: 21.3pt; top: 768.21pt">
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 0pt; top: 1.26pt"
          >{{
            ifq(
              "18.有一種說法「吃檳榔即使不加配料，也會導致癌症」（配料：包括紅灰、白灰、荖花、荖藤、荖葉…等等），請問您認為這種說法對不對？",
              "0.對",
              "■",
              "□"
            )
          }}0.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 25pt; top: 1.26pt"
          >對&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 43.75pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 56.25pt; top: 1.26pt"
          >{{
            ifq(
              "18.有一種說法「吃檳榔即使不加配料，也會導致癌症」（配料：包括紅灰、白灰、荖花、荖藤、荖葉…等等），請問您認為這種說法對不對？",
              "1.不對",
              "■",
              "□"
            )
          }}1.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 81.25pt; top: 1.26pt"
          >不對</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 106.25pt; top: 1.26pt"
          >&nbsp;</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 125pt; top: 1.26pt"
          >{{
            ifq(
              "18.有一種說法「吃檳榔即使不加配料，也會導致癌症」（配料：包括紅灰、白灰、荖花、荖藤、荖葉…等等），請問您認為這種說法對不對？",
              "2.不知道",
              "■",
              "□"
            )
          }}2.</span
        >
        <span
          class="wcspan wctext001"
          style="font-size: 12.5pt; left: 150pt; top: 1.26pt"
          >不知道</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import MixinBigQuiz from "@/mixins/bigQuiz";
import "@/assets/bigQuiz.scss";
export default {
  mixins: [MixinBigQuiz],
};
</script>
